import { api } from "@/api/axios.ts";
import { ApiFile, ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiEmployeePortalAccessReleasePayload,
  ApiEmployeePortalAccessStatus,
  ApiPreboardingHome,
} from "@/types/preboarding.types.ts";
import { ApiTask } from "@/types/task.types.ts";

export const apiPreboarding = {
  getHome: (signal?: AbortSignal) => {
    return api.get<ApiPreboardingHome>("/api/v1/preboarding/home", undefined, signal);
  },
  getEmployeePortalAccess: (employeeId: number, signal?: AbortSignal) => {
    return api.get<ApiEmployeePortalAccessStatus>(
      `/api/v1/employees/${employeeId}/portal-access`,
      undefined,
      signal
    );
  },
  releaseEmployeePortalAccess: (
    employeeId: number,
    payload: ApiEmployeePortalAccessReleasePayload
  ) => {
    return api.post<ApiEmployeePortalAccessStatus>(
      `/api/v1/employees/${employeeId}/portal-access/release`,
      payload
    );
  },
  completeTask: (taskId: number) => {
    return api.post<ApiOperationResult>(`/api/v1/tasks/${taskId}/complete`, {});
  },
  startTask: (taskId: number) => {
    return api.post<ApiTask>(`/api/v1/tasks/${taskId}/start`, {});
  },
  stopTask: (taskId: number) => {
    return api.post<ApiTask>(`/api/v1/tasks/${taskId}/stop`, {});
  },
  attachTaskFile: (taskId: number, formData: FormData) => {
    return api.post<ApiFile>(`/api/v1/tasks/${taskId}/files`, formData);
  },
  detachTaskFile: (taskId: number, fileUuid: string) => {
    return api.delete<ApiOperationResult>(`/api/v1/tasks/${taskId}/files/${fileUuid}`);
  },
};
